var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12561 29.2214H9.86726",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00073 25.2783V30.4504",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3237 25.0878H5.66474C5.10469 25.0878 4.65063 24.6337 4.65063 24.0737C4.65063 23.5137 5.10469 23.0596 5.66474 23.0596H10.3237C10.8837 23.0596 11.3378 23.5137 11.3378 24.0737C11.3378 24.6337 10.8838 25.0878 10.3237 25.0878Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8639 29.2214H15.1383",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0007 25.2783V30.5147",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3362 25.0878H14.6773C14.1173 25.0878 13.6632 24.6337 13.6632 24.0737C13.6632 23.5137 14.1173 23.0596 14.6773 23.0596H19.3362C19.8962 23.0596 20.3503 23.5137 20.3503 24.0737C20.3503 24.6337 19.8962 25.0878 19.3362 25.0878Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8799 29.2214H24.1383",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0009 25.2783V30.5147",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3363 25.0878H23.6774C23.1174 25.0878 22.6633 24.6337 22.6633 24.0737C22.6633 23.5137 23.1174 23.0596 23.6774 23.0596H28.3363C28.8964 23.0596 29.3504 23.5137 29.3504 24.0737C29.3504 24.6337 28.8965 25.0878 28.3363 25.0878Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9991 20.3312H1.32255C1.14484 20.3312 1.00061 20.1871 1.00061 20.0093V18.419C1.00061 18.2406 1.14484 18.097 1.32255 18.097H22.3491",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6007 18.097H32.6776C32.8552 18.097 32.9995 18.2406 32.9995 18.419V20.0093C32.9995 20.1871 32.8552 20.3312 32.6776 20.3312H7.25073",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0054 17.9195V13.0562C17.0054 12.6597 16.8558 12.2778 16.5867 11.9866C16.3174 11.6954 16.168 11.3135 16.168 10.917V8.074C16.168 7.93653 16.0564 7.82507 15.919 7.82507H14.5746C14.4372 7.82507 14.3257 7.93653 14.3257 8.074V10.917C14.3257 11.3135 14.1762 11.6954 13.907 11.9866C13.6378 12.2778 13.4883 12.6597 13.4883 13.0562V17.9195",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4508 9.51103H16.0489",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9883 13.0562C16.9883 12.6597 17.1379 12.2778 17.407 11.9866C17.6763 11.6954 17.8257 11.3135 17.8257 10.917V8.074C17.8257 7.93653 17.9373 7.82507 18.0747 7.82507H19.419C19.5565 7.82507 19.668 7.93653 19.668 8.074V10.917C19.668 11.3135 19.8174 11.6954 20.0867 11.9866C20.3558 12.2778 20.5054 12.6597 20.5054 13.0562V17.9195",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5489 9.51103H17.9508",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.307 29.723V32.1781C31.307 32.3558 31.1627 32.5 30.9851 32.5H3.02262C2.84491 32.5 2.70068 32.3558 2.70068 32.1781V20.4736",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3009 27.4694V20.5284",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5472 16.048C6.8104 16.048 6.21313 15.4507 6.21313 14.714V12.7361H8.88124V14.714C8.88124 15.4507 8.28399 16.048 7.5472 16.048Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53821 16.2782V17.6706",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4598 16.048C27.1966 16.048 27.7939 15.4507 27.7939 14.714V12.7361H25.1259V14.714C25.1259 15.4507 25.7231 16.048 26.4598 16.048Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4634 16.2782V17.6706",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2972 6.16881C6.03399 6.16881 6.63124 6.76606 6.63124 7.50285V9.48079H3.96313V7.50285C3.96313 6.76606 4.5604 6.16881 5.2972 6.16881Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30066 5.93907V4.02191",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79718 6.16881C10.534 6.16881 11.1312 6.76606 11.1312 7.50285V9.48079H8.46313V7.50285C8.46313 6.76606 9.0604 6.16881 9.79718 6.16881Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80066 6.00345V4.02191",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1974 6.16881C24.9342 6.16881 25.5313 6.76606 25.5313 7.50285V9.48079H22.8633V7.50285C22.8633 6.76606 23.4606 6.16881 24.1974 6.16881Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2008 6.00345V4.02191",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6975 6.16881C29.4343 6.16881 30.0314 6.76606 30.0314 7.50285V9.48079H27.3634V7.50285C27.3634 6.76606 27.9607 6.16881 28.6975 6.16881Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7009 6.00345V4.02191",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53821 4.65457V0.5",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4634 4.65457V0.5",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6568 2.16095H26.461H29.1415C29.6378 2.16095 30.0402 2.56337 30.0402 3.05981C30.0402 3.3077 29.9399 3.53304 29.7768 3.6953C29.614 3.85821 29.39 3.95865 29.1415 3.95865H26.461H7.54247H4.86199C4.36555 3.95865 3.96313 3.55623 3.96313 3.05981C3.96313 2.8119 4.06358 2.58655 4.22648 2.4243C4.38938 2.26138 4.61345 2.16095 4.86199 2.16095H7.54247H10.4032",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86726 32.4371C9.86726 31.5629 9.02964 30.8542 7.99641 30.8542C6.96317 30.8542 6.12561 31.5629 6.12561 32.4371",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8799 32.4371C18.8799 31.5629 18.0423 30.8542 17.009 30.8542C15.9759 30.8542 15.1383 31.5629 15.1383 32.4371",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8799 32.4371C27.8799 31.5629 27.0423 30.8542 26.009 30.8542C24.9759 30.8542 24.1383 31.5629 24.1383 32.4371",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.51f46e0bf5e8ede3272672dcf014b2e4.svg";
export { ForwardRef as ReactComponent };